// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Atom_Box from "../../atom/Atom_Box.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as UseOnBlur from "../../../hook/UseOnBlur.bs.js";
import * as UseToggle from "../../../hook/UseToggle.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Atom_Divider from "../../atom/Atom_Divider.bs.js";
import * as UseClickOutside from "../../../hook/UseClickOutside.bs.js";
import * as Organism_Menu_Ds from "./Organism_Menu_Ds.bs.js";
import * as Organism_Menu_Css from "./Organism_Menu_Css.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Organism_Menu_Brand from "./Organism_Menu_Brand.bs.js";
import * as Organism_Menu_Items from "./Organism_Menu_Items.bs.js";
import * as Organism_Menu_Search from "./Organism_Menu_Search.bs.js";
import * as Molecule_BurgerMenuIcon from "../../molecule/Molecule_BurgerMenuIcon.bs.js";

var displayNoneMediumFlex = Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none");

function Organism_Menu(Props) {
  var brand = Props.brand;
  var buttonMore = Props.buttonMore;
  var currentLinkId = Props.currentLinkId;
  var links = Props.links;
  var navLabel = Props.navLabel;
  var account = Props.account;
  var search = Props.search;
  var style = Props.style;
  var match = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match.close;
  var state = match.state;
  var ref = React.useRef(null);
  UseClickOutside.make(ref, close);
  UseOnBlur.make(ref, close);
  var view = React.useMemo((function () {
          return Organism_Menu_Ds.view(style);
        }), [style]);
  var dividerStyle = view.dividerStyle;
  var burgerDisplay = Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "flex");
  var displayBlockMediumFlex = Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "block");
  var menuDisplay = state ? displayNoneMediumFlex : displayBlockMediumFlex;
  var divider = dividerStyle !== undefined ? React.createElement(Atom_Divider.make, {
          style: dividerStyle,
          display: displayNoneMediumFlex
        }) : null;
  var match$1;
  if (search !== undefined) {
    var id = search.id;
    match$1 = [
      React.createElement(React.Fragment, undefined, divider, React.createElement(Organism_Menu_Search.make, {
                screenReadersLabel: search.screenReadersLabel,
                styleButton: view.searchCtaStyle,
                placeholder: search.placeholder,
                onSubmit: search.onSubmit,
                view: view,
                id: id
              })),
      id
    ];
  } else {
    match$1 = [
      null,
      undefined
    ];
  }
  var match$2;
  if (account !== undefined) {
    var id$1 = account.id;
    var isCurrent = Belt_Option.map(currentLinkId, (function (currentLinkId) {
            return currentLinkId === id$1;
          }));
    var tmp = {
      ariaLabel: account.ariaLabel,
      id: id$1,
      label: account.label,
      subLinks: account.subLinks,
      title: account.title,
      highlight: account.highlight,
      isCurrent: isCurrent,
      view: view
    };
    if (account.href !== undefined) {
      tmp.href = Caml_option.valFromOption(account.href);
    }
    match$2 = [
      React.createElement(Organism_Menu_Items.Link.make, tmp),
      id$1
    ];
  } else {
    match$2 = [
      null,
      undefined
    ];
  }
  var tmp$1 = {
    view: view,
    children: React.createElement(Molecule_BurgerMenuIcon.make, {
          state: state,
          toggle: match.toggle,
          style: view.burgerStyle,
          display: burgerDisplay
        })
  };
  if (brand !== undefined) {
    tmp$1.brand = Caml_option.valFromOption(brand);
  }
  var tmp$2 = {
    links: links,
    view: view,
    buttonMore: buttonMore,
    refRoot: ref,
    children: null
  };
  if (currentLinkId !== undefined) {
    tmp$2.currentLinkId = Caml_option.valFromOption(currentLinkId);
  }
  var tmp$3 = match$1[1];
  if (tmp$3 !== undefined) {
    tmp$2.searchButtonId = Caml_option.valFromOption(tmp$3);
  }
  return React.createElement(Atom_Box.make, {
              background: view.background,
              children: null,
              display: displayBlockMediumFlex,
              justifyContent: view.justifyContent,
              kind: {
                TAG: /* Nav */10,
                _0: navLabel
              },
              rules: Organism_Menu_Css.rulesContainer,
              ref_: ref
            }, React.createElement(Organism_Menu_Brand.make, tmp$1), React.createElement(Atom_Row.make, {
                  children: React.createElement(Organism_Menu_Items.make, tmp$2, match$1[0], match$2[0]),
                  display: menuDisplay
                }));
}

var make = Organism_Menu;

export {
  displayNoneMediumFlex ,
  make ,
}
/* displayNoneMediumFlex Not a pure module */
